"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var DefaultSpinner = function DefaultSpinner(_ref) {
  var _ref$overlay = _ref.overlay,
    overlay = _ref$overlay === void 0 ? false : _ref$overlay,
    children = _ref.children;
  var renderDefaultSpinnerNode = function renderDefaultSpinnerNode() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "loading-spinner"
    }, children));
  };
  var renderDefaultSpinnerWithOverlay = function renderDefaultSpinnerWithOverlay() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "loading-spinner--overlay"
    }, renderDefaultSpinnerNode());
  };
  return /*#__PURE__*/_react.default.createElement("div", null, overlay ? renderDefaultSpinnerWithOverlay() : renderDefaultSpinnerNode());
};
DefaultSpinner.propTypes = {
  overlay: _propTypes.default.bool,
  children: _propTypes.default.node
};
var _default = DefaultSpinner;
exports.default = _default;